module.exports = __webpack_public_path__ + "img/senegal-logo-icon.884a8c0d.png";